export var getMapStateToInputSectionProps = function getMapStateToInputSectionProps(_ref) {
  var changePaymentTypeButtonProps = _ref.changePaymentTypeButtonProps,
    mapStateToPhoneInputProps = _ref.mapStateToPhoneInputProps,
    mapStateToSumInputProps = _ref.mapStateToSumInputProps;
  return function (state, setState) {
    return {
      changePaymentTypeButtonProps: changePaymentTypeButtonProps(state, setState),
      phoneInputProps: mapStateToPhoneInputProps(state, setState),
      toggleProps: [],
      sumInputProps: mapStateToSumInputProps(state, setState)
    };
  };
};